<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="navbar-brand" to="/">
                <img :src="logoUrl" class="navbar-brand-img" alt="...">
            </router-link>

            <slot name="mobile-right">
            </slot>
            <slot></slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img :src="logoUrl">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>

                <template v-if="roles &&(roles.includes('superadmin') || roles.includes('admin'))">
                  <!--Divider-->
                  <hr class="my-3">
                  <!--Heading-->
                  <h6 class="navbar-heading text-muted">Üst Yetkiler</h6>
                  <!--Navigation-->
                  <ul class="navbar-nav mb-md-3">
                    <!-- <li class="nav-item">
                      <b-link :to="{name: 'sellers'}" class="nav-link">
                        <i class="ni ni-spaceship"></i> Bayiler
                      </b-link>
                    </li> -->
<!--                    <sidebar-dropdown color="primary" name="Ürün ve Sipariş" icon="ni ni-atom">-->
<!--                      <sidebar-item label="Yeni Siparişler" icon="ni ni-bullet-list-67" :to="{ name: 'super-product-orders' }" />-->
<!--                      <sidebar-item label="Ürün Listesi" icon="ni ni-bullet-list-67" :to="{ name: 'super-products' }" />-->
<!--                    </sidebar-dropdown>-->

                    <sidebar-dropdown color="primary" name="Bayi Kontrolü" icon="ni ni-atom">
                      <sidebar-item label="Tüm Ürünler" icon="ni ni-bullet-list-67" :to="{ name: 'services', params:{type:'all'} }" />
<!--                      <sidebar-item label="Kiralık Ürünler" icon="ni ni-bullet-list-67" :to="{ name: 'leased-products', params:{type:'all'} }" />-->
                      <sidebar-item label="Tüm Kasalar" icon="ni ni-bullet-list-67" :to="{ name: 'gecmis-kasa', params:{type:'all'} }" />
                      <sidebar-item label="Satış Raporları" icon="ni ni-bullet-list-67" :to="{ name: 'sales-reports', params:{type:'all'} }" />
                      <sidebar-item label="Gelir Gider Raporları" icon="ni ni-bullet-list-67" :to="{ name: 'incomeexpenses-reports', params:{type:'all'} }" />
                      <sidebar-item label="Personel Raporları" icon="ni ni-bullet-list-67" :to="{ name: 'employee-reports', params:{type:'all'} }" />
<!--                      <sidebar-item label="Provalar" icon="ni ni-bullet-list-67" :to="{ name: 'appointments-list', params:{type:'all'} }" />-->
<!--                      <sidebar-item label="Küaför Randevuları" icon="ni ni-bullet-list-67" :to="{ name: 'coiffeur-appointments-list', params:{type:'all'} }" />-->
                    </sidebar-dropdown>
                    <li class="nav-item">
                      <b-link :to="{name: 'companies'}" class="nav-link">
                        <i class="ni ni-palette"></i> Müşteri Yönetimi
                      </b-link>
                    </li>
<!--                    <li class="nav-item">-->
<!--                      <b-link :to="{name: 'surplusproducts'}" class="nav-link">-->
<!--                        <i class="ni ni-palette"></i> Barkod Kontrolü (Fazlalık ürünler)-->
<!--                      </b-link>-->
<!--                    </li>-->
                    <li class="nav-item">
                      <b-link :to="{name: 'announces'}" class="nav-link">
                        <i class="ni ni-bell-55"></i> Duyurular
                      </b-link>
                    </li>
                    <!-- <li class="nav-item">
                      <b-link :to="{name: 'system-management'}" class="nav-link">
                        <i class="ni ni-ui-04"></i> Sistem Yönetimi
                      </b-link>
                    </li> -->
                  </ul>
                </template>
            </div>
            </div>
    </nav>
</template>
<script>
  import SidebarDropdown from '../../components/SidebarDropdown'
  import NavbarToggleButton from '../NavbarToggleButton'
  import { mapGetters } from 'vuex'

  export default {
    name: 'sidebar',
    components: {
      NavbarToggleButton,
      SidebarDropdown,
    },
    props: {
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    computed: {
      ...mapGetters(['user', 'roles']),
      logoUrl () {
        return this.user && this.user.company.logo_url ? this.user.company.logo_url : ''
      },
    },
    methods: {
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      }
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>
